import { BranchInfo } from "../../Models";
import { isVirtualBranch } from "../../helpers";
import { urlFormatter } from "sb-resp-utils";
var BranchesParser = /** @class */ (function () {
    function BranchesParser() {
    }
    BranchesParser.prototype.parseData = function (sport) {
        return new BranchInfo(this.prepareData(sport));
    };
    BranchesParser.prototype.prepareData = function (sport) {
        var id = sport.id ? parseInt(sport.id) : 0;
        var rankId = sport.order ? sport.order : 0;
        var liveFixturesTotalCount = sport.liveFixturesTotalCount ? sport.liveFixturesTotalCount : 0;
        var sportName = sport.name ? sport.name : "";
        return {
            ID: id,
            Name: sportName,
            RankID: rankId,
            SortID: rankId,
            Code: urlFormatter.getSportUrl(sportName),
            MasterEvents: [],
            EventNames: ["1x2", "Spread", "Over/Under"],
            TotalLiveCount: liveFixturesTotalCount,
            IsVirtualSport: isVirtualBranch(id),
            Visible: true,
            AllLiveVisible: false,
            hasLiveEvents: liveFixturesTotalCount !== 0
        };
    };
    return BranchesParser;
}());
export { BranchesParser };
//# sourceMappingURL=BranchesParser.js.map